/* Cookie consent popup — markup in snippets/cookie-consent.liquid.
 *
 * The decision is stored through Shopify's Customer Privacy API, so Shopify analytics,
 * app Web Pixels and Checkout all honour it. A first-party cookie (fi_cc) mirrors it so
 * the popup stays closed even if the API fails to load.
 *
 * Shown until the visitor has answered this popup (fi_cc set). Reopen with window.FICookieConsent.open()
 * or any link to #cookie-settings / [data-cookie-settings].
 */
(function () {
  'use strict';

  var root = document.getElementById('FiCookieConsent');
  if (!root) return;

  var COOKIE = 'fi_cc';
  var OPTIONAL = ['preferences', 'analytics', 'marketing'];
  var banner = root.querySelector('.fi-cc__banner');
  var panel = root.querySelector('[data-cc-panel]');
  var overlay = root.querySelector('[data-cc-overlay]');
  var lastFocus = null;
  var cssReady = null;

  /* ---------- storage ---------- */
  function readCookie() {
    var m = document.cookie.match(/(?:^|;\s*)fi_cc=([^;]+)/);
    if (!m) return null;
    try {
      return JSON.parse(decodeURIComponent(m[1]));
    } catch (e) {
      return null;
    }
  }
  function writeCookie(choice) {
    var v = encodeURIComponent(JSON.stringify(choice));
    document.cookie = COOKIE + '=' + v + ';path=/;max-age=' + 60 * 60 * 24 * 365 + ';SameSite=Lax' +
      (location.protocol === 'https:' ? ';Secure' : '');
  }

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  /* Resolves once Shopify's consent API is ready, or after 3s without it. */
  function whenPrivacy(cb) {
    if (privacy()) return cb(privacy());
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      cb(privacy() || null);
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    }
    setTimeout(finish, 3000);
  }

  function apiDecision(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;
    var c = api.currentVisitorConsent() || {};
    if (!c.analytics && !c.marketing && !c.preferences) return null;
    return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes', preferences: c.preferences === 'yes' };
  }

  function current() {
    return apiDecision(privacy()) || readCookie() || { preferences: false, analytics: false, marketing: false };
  }

  /* ---------- save ---------- */
  function save(choice) {
    writeCookie(choice);
    whenPrivacy(function (api) {
      if (api && typeof api.setTrackingConsent === 'function') {
        api.setTrackingConsent(
          {
            analytics: choice.analytics,
            marketing: choice.marketing,
            preferences: choice.preferences,
            sale_of_data: choice.marketing
          },
          function () {}
        );
      }
    });
    document.dispatchEvent(new CustomEvent('fi:cookie-consent', { detail: choice }));
    closePanel();
    hideBanner();
  }

  function all(value) {
    return { preferences: value, analytics: value, marketing: value };
  }

  function fromToggles() {
    var c = all(false);
    OPTIONAL.forEach(function (k) {
      var el = panel.querySelector('[data-cc-toggle="' + k + '"]');
      c[k] = !!(el && el.checked);
    });
    return c;
  }

  /* ---------- show / hide ---------- */
  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (resolve) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = root.getAttribute('data-css');
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
      setTimeout(resolve, 2500);
    });
    return cssReady;
  }

  function showBanner() {
    loadCss().then(function () {
      root.hidden = false;
      root.classList.remove('is-closing');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
      });
    });
  }

  function hideBanner() {
    if (root.hidden) return;
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-closing');
    }, 550);
  }

  function openPanel() {
    loadCss().then(function () {
      var c = current();
      OPTIONAL.forEach(function (k) {
        var el = panel.querySelector('[data-cc-toggle="' + k + '"]');
        if (el) el.checked = !!c[k];
      });
      lastFocus = document.activeElement;
      root.hidden = false;
      overlay.hidden = false;
      panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      panel.focus();
    });
  }

  function closePanel() {
    if (panel.hidden) return;
    panel.hidden = true;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (!root.classList.contains('is-open')) root.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-cc-overlay]');
    if (!t) return;
    if (t.hasAttribute('data-cc-accept')) save(all(true));
    else if (t.hasAttribute('data-cc-reject')) save(all(false));
    else if (t.hasAttribute('data-cc-save')) save(fromToggles());
    else if (t.hasAttribute('data-cc-manage')) openPanel();
    else if (t.hasAttribute('data-cc-close') || t.hasAttribute('data-cc-overlay')) closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closePanel();
    if (e.key === 'Tab' && !panel.hidden) {
      var f = panel.querySelectorAll('button, input, a[href]');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#cookie-settings"], [data-cookie-settings]');
    if (!link) return;
    e.preventDefault();
    openPanel();
  });

  window.FICookieConsent = { open: openPanel, get: current };

  /* ---------- first visit ----------
     Only our own cookie counts as "answered". A decision already in the Customer Privacy
     API is not enough: cookie apps (CookieYes) and Shopify itself write one there without
     asking — e.g. auto-granted for regions they don't show a banner in — which kept this
     popup from ever appearing. The API value still pre-fills the preference toggles. */
  if (readCookie()) return;
  /* A short beat after load so it reads as an entrance, not a layout glitch. */
  setTimeout(showBanner, 600);
})();
